import React from 'react';

const DrtPage = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
      Drt Page
    </div>
  );
};

export default DrtPage;
